/**
 * Helper component for rendering basic checkbox inputs
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../helpers/Tooltip';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const CheckboxInput = ({
  change
  , className = ''
  , disabled
  , helpText
  , label
  , name
  , placeholder
  , required
  , value = false
  , heightClass
  , labelClass
}) => {
  return (
    <div className={`mb-2 ${className}`}>
      <div className={`flex items-center w-min hover:${disabled ? '' : 'bg-neutral-sec'}`}>
        <input
          disabled={disabled}
          className={`${heightClass ? heightClass : "h-5 w-5"} rounded accent-success-600`}
          checked={!!value}
          name={name}
          onChange={e => {
            change({
              target: {
                name: name
                , value: e.target.checked
              }
            })
          }}
          placeholder={placeholder}
          required={required}
          type="checkbox"
          value={value}
        />
        {label ? (
          <label
            htmlFor={name}
            className={`${labelClass ? labelClass : "ml-1 text-xs inline-block whitespace-nowrap"}`}
          >
            {label} {required && <sup className="text-red-500">*</sup>}
            {helpText && (
              <Tooltip text={helpText}>
                <InformationCircleIcon className="h-4 w-4 text-neutral-ter" />
              </Tooltip>
            )}
          </label>
        )
          :
          null
        }
      </div>
      {/* {helpText && <small className="pl-2 text-xs text-gray-500"><em>{helpText}</em></small>} */}
    </div>
  )
}

CheckboxInput.propTypes = {
  change: PropTypes.func.isRequired
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.oneOfType([
    PropTypes.string
    , PropTypes.element
  ])
  , name: PropTypes.string.isRequired
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , value: PropTypes.bool
  , labelClass: PropTypes.string
}

CheckboxInput.defaultProps = {
  disabled: false
  , helpText: null
  , label: ''
  , placeholder: ''
  , required: false
}

export default CheckboxInput;
